module.exports = __webpack_public_path__ + "static/media/visa.e9498175.svg";